export default [

     {
          path: '/term',
          name: 'Term',
          component: () => import("@/views/Page/Term/Term.vue"),
          meta: {
               title: 'Term',
          },
     },

     {
          path: '/terms/:id',
          name: 'TermDetails',
          component: () => import('@/views/Page/Glossary/TermDetails.vue'),
          meta: {
               title: 'Term',
          },
     }

];